module.exports = __webpack_public_path__ + "static/media/tiles-left-first-section.d9bfb864.svg";